import React from 'react'
import PropTypes from 'prop-types'

// One start type as a segment; the hidden native radio still drives it, and refuses a disabled click.

const TeeTimeTypeOption = ({ value, checked, onChange, name, disabled }) => (
  <label
    className={`gl-event-setup-tt-seg-opt${checked ? ' is-selected' : ''}${disabled ? ' is-disabled' : ''}`}
    >
    <input
      className="gl-event-setup-tt-hidden-radio"
      type="radio"
      name="pair-tt-type"
      value={value}
      checked={checked}
      disabled={disabled}
      aria-disabled={disabled}
      onChange={() => onChange(value)}
    />
    <span className="gl-event-setup-tt-seg-name">{name}</span>
  </label>
)

TeeTimeTypeOption.propTypes = {
  value: PropTypes.oneOf([ 'teetimes', 'shotgun', 'walkon' ]).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}

export default TeeTimeTypeOption
